import { CloseOutlineIcon } from '@carboncopyco/icons';
import classNames from 'classnames';
import { AnimatePresence, motion } from 'framer-motion';
import type React from 'react';
import { Button } from '../Button';
import { Spacer } from '../Spacer';
import { TooltipBubble } from '../TooltipBubble';
import { TextBoxEditorTitle } from '../Typography';

const transition = {
  type: 'spring',
  stiffness: 500,
  damping: 100,
};

export interface DrawerProps {
  width?: number;
  isOpen?: boolean;
  header?: string | React.ReactNode;
  onClose?: () => void;
  children: React.ReactNode;
  left?: boolean;
  noScroll?: boolean;
}

export const Drawer = ({
  width = 400,
  isOpen,
  header,
  onClose,
  children,
  left,
  noScroll,
}: DrawerProps) => {
  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          style={{ width }}
          initial="hidden"
          animate="visible"
          exit="hidden"
          transition={transition}
          className={classNames(
            'top-0 bottom-0 bg-ds-accent3-100 absolute z-10 h-full flex flex-col py-6 shadow-x-large',
            left ? 'left-0' : 'right-0',
            noScroll ? 'overflow-hidden' : 'overflow-hidden overflow-y-auto'
          )}
          variants={{
            visible: { x: 0 },
            hidden: { x: left ? -width : width },
          }}
        >
          <div className="flex items-center justify-between px-4">
            {typeof header === 'string' ? (
              <TextBoxEditorTitle
                label={header}
                color="text-ds-natural-200"
                uppercase
              />
            ) : (
              header
            )}
            {onClose && (
              <TooltipBubble
                placement="top"
                title="Close"
              >
                <div className="ml-3 h-7 flex items-center">
                  <Button
                    icon={<CloseOutlineIcon />}
                    secondary
                    link
                    onClick={onClose}
                  />
                </div>
              </TooltipBubble>
            )}
          </div>
          <Spacer />
          {children}
        </motion.div>
      )}
    </AnimatePresence>
  );
};
